import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";

import BreadCrumb from "../../BreadCrumb";

import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import {
  addDownload,
  editDownload,
  updateDownload,
} from "../../../store/actions/councilActions/downloadActions";

const breadcrumbs = [
  {
    path: "/admin/dashboard",
    label: "Dashboard",
  },
  {
    label: "Add Download",
  },
];

const AddDownload = () => {
  const [loading, setLoading] = useState(false);
  const [exist, setExist] = useState(true);
  const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams();

  const initialState = {
    title: "",
    posted_date: "",
  };
  const [data, setData] = useState(initialState);
  const fetchData = async () => {
    setLoading(true);
    const response = await dispatch(editDownload(id));
    if (response) {
      setData({
        title: response.title,
        posted_date: response.posted_date,
      });
      setLoading(false);
    } else {
      setLoading(false);
      setExist(false);
    }
  };
  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, []);
  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const { title, posted_date } = data;
  const [file, setFile] = useState([]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formdata = new FormData();
    formdata.append("title", title);
    formdata.append("posted_date", posted_date);
    formdata.append("file", file);
    if (id) {
      formdata.append("link_id", id);
      const response = await dispatch(updateDownload(formdata));
      if (response) {
        setData(initialState);
        history.push("/admin/download/list");
      }
    } else {
      const response = await dispatch(addDownload(formdata));
      if (response) {
        setData(initialState);
        history.push("/admin/download/list");
      }
    }
  };
  return (
    <div className="row">
      <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
        <div class="subheader py-2 py-lg-6 subheader-solid" id="kt_subheader">
          <div class="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
            <BreadCrumb crumbs={breadcrumbs} />

            <div class="d-flex align-items-center">
              <Link
                to="/admin/download/list"
                class="btn btn-light-primary font-weight-bolder btn-sm"
              >
                Downloads List
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8 card">
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" role="status" size="lg">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : exist ? (
            <>
              <div className="card-header text-center">
                {id ? "Edit Office" : " Add Download"}
              </div>
              <div class="myForm">
                <form onSubmit={handleSubmit}>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="boxlabel">
                            <p> Title</p>
                            <input
                              type="text"
                              name="title"
                              value={title}
                              onChange={handleChange}
                              class="form-control"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="boxlabel">
                            <p>Posted Date</p>
                            <input
                              type="date"
                              name="posted_date"
                              value={posted_date}
                              onChange={handleChange}
                              class="form-control"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="boxlabel">
                            <p>PDF</p>
                            <input
                              type="file"
                              accept="application/pdf"
                              onChange={(e) => {
                                setFile(e.target.files[0]);
                              }}
                              class="form-control"
                              required
                            />
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div
                            class="btn-groups mt-4 text-right"
                            role="group"
                            aria-label="First group"
                          >
                            <button class="btn btn-Next" type="submit">
                              Submit<span></span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </>
          ) : (
            <h5>No Record Found</h5>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddDownload;
